export const GET_COUNTRIES = `
query {
    get_countries {
        success
        errorText
        data {
            id
            name_en
            name_he
            iso
            country_code
            icon
        }
    }
}
`;
